import React from "react";
var __jsx = React.createElement;
import stl from "../../Layout.module.css";
/**
 * Bottom-pinned container for a page's own sticky CTA.
 *
 * The bottom navigation bar used to double as this container: pages passed
 * `customStikeyButton` and NavBar rendered it in place of its nav items
 * (financing, landing pages, car prices). The nav bar is gone, but that CTA
 * contract has to keep working, so this is the positioning shell on its own —
 * same `botomNavContainer` styling, no navigation items.
 */
var StickyBottomSlot = function StickyBottomSlot(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.botomNavContainer, "m-show pt-4 pb-2"].join(" "),
    "data-id": "sticky-bottom-slot"
  }, children);
};
export default StickyBottomSlot;